import React from "react";

import { FullPageNotionEmbed, Header } from "src/shared/components";

const NOTION_PAGE_URL =
  "https://hackthenorth.notion.site/ebd/3b5b70e03de780609d7fc423f61ccc15";

export const JudgingFAQ: React.FC = () => (
  <>
    <Header title="FAQ" subtitle="Answers to all your judging questions" />
    <FullPageNotionEmbed
      url={NOTION_PAGE_URL}
      title="Judging FAQ Notion page"
    />
  </>
);
